import { GET_STARTED_CHECKLIST_IS_MINIMIZED } from 'constants/localStorage';

import { useStoredStateForUser } from './utils';

export const useGetStartedChecklistState = () => {
  return useStoredStateForUser(GET_STARTED_CHECKLIST_IS_MINIMIZED);
};
